export enum ReportSources {
    Telerik = 1,
    PowerBI = 2,
    ExternalLink = 3,
  }


// WEBPACK FOOTER //
// ./src/app/core/components/reports/models/enums.ts